/** The id of each shell's main region: the skip link's target and where focus lands after the session banner closes. */
export const MAIN_ID = "main";
